import { render, staticRenderFns } from "./vcSelectGeneric.vue?vue&type=template&id=72ea7469&"
import script from "./vcSelectGeneric.vue?vue&type=script&lang=js&"
export * from "./vcSelectGeneric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports